import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ModalController } from 'ionic-angular';
import { EbsWebService } from "../../services/ebsWebService";
import { TreeViewDetailModalPage } from '../tree-view-detail-modal/tree-view-detail-modal';

@IonicPage()
@Component({
  selector: 'page-treeview',
  templateUrl: 'treeview.html',
})
export class TreeviewPage {

  actionUrl: string;

  selectedRow: any;
  parsedTree: any;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public loadingCtrl: LoadingController,
    private _ebsWebService: EbsWebService,
    public modalCtrl: ModalController) {
    this.actionUrl = navParams.get('actionURL');
  }

  ionViewDidLoad() {

  }

  ionViewWillEnter() {
    console.log(this.actionUrl);
    if (typeof this.actionUrl != "undefined") {
      let loading = this.loadingCtrl.create({
        content: 'Bitte warten...'
      });
      loading.present();
      let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.navParams.get('postParams'));
      this._ebsWebService.postData(this.actionUrl, postPayloadObject).subscribe(res => {
        this.processData(res);
        loading.dismiss();
      });
    } else {
      this.processData(this.demodata);
    }
  }

  processData(data) {
    this.parseTreeRecursive(data, 0);
    console.log(data);
    this.parsedTree = data;
  }

  parseTreeRecursive(data, counter) {
    if (Array.isArray(data)) {
      data.forEach(element => {
        this.parseTreeRecursive(element, counter);
      })
    } else {
      if (data.ListItemContent != null && typeof data.ListItemContent == 'object' && data.ListItemContent.length > 0) {
        let treeData = [];
        data.ListItemContent.forEach(element => {
          if (element.GroupTemplateIdentifier == 'RowIcon' || element.GroupTemplateIdentifier == 'RowText') {
            treeData.push(element);
          }
        });
        let parsed = this._ebsWebService.prepareWebServiceDataForView(data);
        parsed['treeData'] = treeData;
        data.depth = counter;
        data.ListItemContent = parsed;
        if (data.ListItemNavigation != null && typeof data.ListItemNavigation == 'object' && data.ListItemNavigation.length > 0) {
          counter++;
          data.ListItemNavigation.forEach(element => {
            this.parseTreeRecursive(element, counter);
          });
        }
      }
    }
  }

  setSelected(element) {
    this.selectedRow = element;
    if (document.getElementById('detail-col').offsetParent == null) { // if detail not visible
      let treeViewDetailModal = this.modalCtrl.create(TreeViewDetailModalPage, { selectedRow: this.selectedRow });
      treeViewDetailModal.present();
    }
    console.log(this.selectedRow.ListItemContent.body);
  }


  demodata: any = [
    {
      "ListItemNavigation": [
        {
          "ListItemContent": [
            {
              "Dynamic": null,
              "ID": null,
              "DataType": "System.Image",
              "GroupDisplayName": null,
              "FieldName": "Detailseite öffnen",
              "LabelCaption": "email.png",
              "DisplayText": "Detailseite öffnen",
              "EditValue": null,
              "Action": "nix",
              "ActionCaption": null,
              "AllowInsert": false,
              "AllowUpdate": false,
              "ListItemAction": [],
              "Language": null,
              "ViewTypeAction": "GridBox",
              "ActionType": null,
              "ListItemNavigation": null,
              "Image": null,
              "ListItemContent": null,
              "TemplateIdentifier": "BodyLeft_def",
              "GroupTemplateIdentifier": "Detail",
              "DisplayTextStyle": null,
              "MinValue": null,
              "MaxValue": null,
              "PostParameters": "nix",
              "EditMask": null,
              "NoticeMode": "",
              "CreatePostParameters": true,
              "OrderNumber": null,
              "ValidationCode": null,
              "Validation": null
            },
            {
              "Dynamic": null,
              "ID": null,
              "DataType": "System.Image",
              "GroupDisplayName": null,
              "FieldName": "Artikel Hinzufügen",
              "LabelCaption": "erstellen.png",
              "DisplayText": "Artikel Hinzufügen",
              "EditValue": null,
              "Action": "nix",
              "ActionCaption": null,
              "AllowInsert": false,
              "AllowUpdate": false,
              "ListItemAction": [],
              "Language": null,
              "ViewTypeAction": "GridBox",
              "ActionType": null,
              "ListItemNavigation": null,
              "Image": null,
              "ListItemContent": null,
              "TemplateIdentifier": "BodyLeft_def",
              "GroupTemplateIdentifier": "Detail",
              "DisplayTextStyle": null,
              "MinValue": null,
              "MaxValue": null,
              "PostParameters": "nix",
              "EditMask": null,
              "NoticeMode": "",
              "CreatePostParameters": true,
              "OrderNumber": null,
              "ValidationCode": null,
              "Validation": null
            },
            {
              "Dynamic": null,
              "ID": null,
              "DataType": "System.Image",
              "GroupDisplayName": null,
              "FieldName": "Ordner Hinzufügen",
              "LabelCaption": "add.png",
              "DisplayText": "Ordner Hinzufügen",
              "EditValue": null,
              "Action": "nix",
              "ActionCaption": null,
              "AllowInsert": false,
              "AllowUpdate": false,
              "ListItemAction": [],
              "Language": null,
              "ViewTypeAction": "GridBox",
              "ActionType": null,
              "ListItemNavigation": null,
              "Image": null,
              "ListItemContent": null,
              "TemplateIdentifier": "BodyLeft_def",
              "GroupTemplateIdentifier": "Detail",
              "DisplayTextStyle": null,
              "MinValue": null,
              "MaxValue": null,
              "PostParameters": "nix",
              "EditMask": null,
              "NoticeMode": "",
              "CreatePostParameters": true,
              "OrderNumber": null,
              "ValidationCode": null,
              "Validation": null
            },
            {
              "Dynamic": null,
              "ID": null,
              "DataType": "System.Image",
              "GroupDisplayName": null,
              "FieldName": "Löschen",
              "LabelCaption": "delete.png",
              "DisplayText": "Löschen",
              "EditValue": null,
              "Action": "nix",
              "ActionCaption": null,
              "AllowInsert": false,
              "AllowUpdate": false,
              "ListItemAction": [],
              "Language": null,
              "ViewTypeAction": "GridBox",
              "ActionType": null,
              "ListItemNavigation": null,
              "Image": null,
              "ListItemContent": null,
              "TemplateIdentifier": "BodyLeft_def",
              "GroupTemplateIdentifier": "Detail",
              "DisplayTextStyle": null,
              "MinValue": null,
              "MaxValue": null,
              "PostParameters": "nix",
              "EditMask": null,
              "NoticeMode": "",
              "CreatePostParameters": true,
              "OrderNumber": null,
              "ValidationCode": null,
              "Validation": null
            },
            {
              "Dynamic": null,
              "ID": null,
              "DataType": "System.Image",
              "GroupDisplayName": null,
              "FieldName": "v_SccNvarchar2",
              "LabelCaption": "Name",
              "DisplayText": "-",
              "EditValue": "-",
              "Action": null,
              "ActionCaption": null,
              "AllowInsert": false,
              "AllowUpdate": true,
              "ListItemAction": [],
              "Language": null,
              "ViewTypeAction": "NONE",
              "ActionType": "",
              "ListItemNavigation": null,
              "Image": "xls.png",
              "ListItemContent": null,
              "TemplateIdentifier": null,
              "GroupTemplateIdentifier": "RowIcon",
              "DisplayTextStyle": null,
              "MinValue": null,
              "MaxValue": null,
              "PostParameters": null,
              "EditMask": null,
              "NoticeMode": "",
              "CreatePostParameters": true,
              "OrderNumber": null,
              "ValidationCode": null,
              "Validation": null
            },
            {
              "Dynamic": null,
              "ID": null,
              "DataType": "System.String",
              "GroupDisplayName": null,
              "FieldName": "v_SccNvarchar2",
              "LabelCaption": "Name",
              "DisplayText": "Unterordner",
              "EditValue": "-",
              "Action": null,
              "ActionCaption": null,
              "AllowInsert": false,
              "AllowUpdate": true,
              "ListItemAction": [],
              "Language": null,
              "ViewTypeAction": "NONE",
              "ActionType": "",
              "ListItemNavigation": null,
              "Image": null,
              "ListItemContent": null,
              "TemplateIdentifier": null,
              "GroupTemplateIdentifier": "RowText",
              "DisplayTextStyle": null,
              "MinValue": null,
              "MaxValue": null,
              "PostParameters": null,
              "EditMask": null,
              "NoticeMode": "",
              "CreatePostParameters": true,
              "OrderNumber": null,
              "ValidationCode": null,
              "Validation": null
            },
            {
              "Dynamic": null,
              "ID": null,
              "DataType": "System.String",
              "GroupDisplayName": null,
              "FieldName": "v_SccNvarchar3",
              "LabelCaption": "Beschreibung",
              "DisplayText": "Beschreibung unterordner",
              "EditValue": "-",
              "Action": null,
              "ActionCaption": null,
              "AllowInsert": false,
              "AllowUpdate": true,
              "ListItemAction": [],
              "Language": null,
              "ViewTypeAction": "NONE",
              "ActionType": "",
              "ListItemNavigation": null,
              "Image": null,
              "ListItemContent": null,
              "TemplateIdentifier": null,
              "GroupTemplateIdentifier": "RowText",
              "DisplayTextStyle": null,
              "MinValue": null,
              "MaxValue": null,
              "PostParameters": null,
              "EditMask": null,
              "NoticeMode": "",
              "CreatePostParameters": true,
              "OrderNumber": null,
              "ValidationCode": null,
              "Validation": null
            },
            {
              "Dynamic": null,
              "ID": null,
              "DataType": "System.String",
              "GroupDisplayName": null,
              "FieldName": "v_SccNvarchar4",
              "LabelCaption": "Zusatztext",
              "DisplayText": "Schlusstext unterordner",
              "EditValue": "-",
              "Action": null,
              "ActionCaption": null,
              "AllowInsert": false,
              "AllowUpdate": true,
              "ListItemAction": [],
              "Language": null,
              "ViewTypeAction": "NONE",
              "ActionType": "",
              "ListItemNavigation": null,
              "Image": null,
              "ListItemContent": null,
              "TemplateIdentifier": null,
              "GroupTemplateIdentifier": "RowText",
              "DisplayTextStyle": null,
              "MinValue": null,
              "MaxValue": null,
              "PostParameters": null,
              "EditMask": null,
              "NoticeMode": "",
              "CreatePostParameters": true,
              "OrderNumber": null,
              "ValidationCode": null,
              "Validation": null
            }
          ],
          "ListItemAction": null,
          "ListItemNavigation": [
            {
              "ListItemContent": [
                {
                  "Dynamic": null,
                  "ID": null,
                  "DataType": "System.Image",
                  "GroupDisplayName": null,
                  "FieldName": "Detailseite öffnen",
                  "LabelCaption": "email.png",
                  "DisplayText": "Detailseite öffnen",
                  "EditValue": null,
                  "Action": "nix",
                  "ActionCaption": null,
                  "AllowInsert": false,
                  "AllowUpdate": false,
                  "ListItemAction": [],
                  "Language": null,
                  "ViewTypeAction": "GridBox",
                  "ActionType": null,
                  "ListItemNavigation": null,
                  "Image": null,
                  "ListItemContent": null,
                  "TemplateIdentifier": "BodyLeft_def",
                  "GroupTemplateIdentifier": "Detail",
                  "DisplayTextStyle": null,
                  "MinValue": null,
                  "MaxValue": null,
                  "PostParameters": "nix",
                  "EditMask": null,
                  "NoticeMode": "",
                  "CreatePostParameters": true,
                  "OrderNumber": null,
                  "ValidationCode": null,
                  "Validation": null
                },
                {
                  "Dynamic": null,
                  "ID": null,
                  "DataType": "System.Image",
                  "GroupDisplayName": null,
                  "FieldName": "Löschen",
                  "LabelCaption": "delete.png",
                  "DisplayText": "Löschen",
                  "EditValue": null,
                  "Action": "nix",
                  "ActionCaption": null,
                  "AllowInsert": false,
                  "AllowUpdate": false,
                  "ListItemAction": [],
                  "Language": null,
                  "ViewTypeAction": "GridBox",
                  "ActionType": null,
                  "ListItemNavigation": null,
                  "Image": null,
                  "ListItemContent": null,
                  "TemplateIdentifier": "BodyLeft_def",
                  "GroupTemplateIdentifier": "Detail",
                  "DisplayTextStyle": null,
                  "MinValue": null,
                  "MaxValue": null,
                  "PostParameters": "nix",
                  "EditMask": null,
                  "NoticeMode": "",
                  "CreatePostParameters": true,
                  "OrderNumber": null,
                  "ValidationCode": null,
                  "Validation": null
                },
                {
                  "Dynamic": null,
                  "ID": null,
                  "DataType": "Accordion",
                  "GroupDisplayName": null,
                  "FieldName": "v_SkdID",
                  "LabelCaption": "Konditionen",
                  "DisplayText": "[JSON{\"Value\":\"4758\",\"Label\":\"46,00 % - Grundrabatt\",\"Style\":\"font-weight: bold;\"},{\"Value\":\"4759\",\"Label\":\"28,00 % - Ausstellungsrabatt \",\"Style\":\"\"},{\"Value\":\"4757\",\"Label\":\"10,00 % - Hausrabatt\",\"Style\":\"font-weight: bold;\"},{\"Value\":\"5621\",\"Label\":\"0,00 % - Sonderrabatt\",\"Style\":\"\"}]",
                  "EditValue": "[{\"Value\":\"4758\",\"Label\":\"46,00 % - Grundrabatt\",\"Style\":\"font-weight: bold;\"},{\"Value\":\"4759\",\"Label\":\"28,00 % - Ausstellungsrabatt \",\"Style\":\"\"},{\"Value\":\"4757\",\"Label\":\"10,00 % - Hausrabatt\",\"Style\":\"font-weight: bold;\"},{\"Value\":\"5621\",\"Label\":\"0,00 % - Sonderrabatt\",\"Style\":\"\"}]",
                  "Action": "https://vertreter.forcher.at:9001/EfwService_ForcherVertreterApp.asmx/SetValueAsJSON",
                  "ActionCaption": null,
                  "AllowInsert": true,
                  "AllowUpdate": true,
                  "ListItemAction": [],
                  "Language": null,
                  "ViewTypeAction": "NONE",
                  "ActionType": "",
                  "ListItemNavigation": null,
                  "Image": null,
                  "ListItemContent": null,
                  "TemplateIdentifier": "BodyRight_def",
                  "GroupTemplateIdentifier": "Detail",
                  "DisplayTextStyle": null,
                  "MinValue": null,
                  "MaxValue": null,
                  "PostParameters": "",
                  "EditMask": null,
                  "NoticeMode": "",
                  "CreatePostParameters": true,
                  "OrderNumber": null,
                  "ValidationCode": null,
                  "Validation": null
                },
                {
                  "Dynamic": null,
                  "ID": null,
                  "DataType": "Accordion",
                  "GroupDisplayName": null,
                  "FieldName": "v_SkdID345",
                  "LabelCaption": "Konditionen345",
                  "DisplayText": "[JSON{\"Value\":\"4758\",\"Label\":\"46,00 % - Grundrabatt\",\"Style\":\"font-weight: bold;\"},{\"Value\":\"4759\",\"Label\":\"28,00 % - Ausstellungsrabatt \",\"Style\":\"\"},{\"Value\":\"4757\",\"Label\":\"10,00 % - Hausrabatt\",\"Style\":\"font-weight: bold;\"},{\"Value\":\"5621\",\"Label\":\"0,00 % - Sonderrabatt\",\"Style\":\"\"}]",
                  "EditValue": "[{\"Value\":\"4758\",\"Label\":\"46,00 % - Grundrabatt\",\"Style\":\"font-weight: bold;\"},{\"Value\":\"4759\",\"Label\":\"28,00 % - Ausstellungsrabatt \",\"Style\":\"\"},{\"Value\":\"4757\",\"Label\":\"10,00 % - Hausrabatt\",\"Style\":\"font-weight: bold;\"},{\"Value\":\"5621\",\"Label\":\"0,00 % - Sonderrabatt\",\"Style\":\"\"}]",
                  "Action": "https://vertreter.forcher.at:9001/EfwService_ForcherVertreterApp.asmx/SetValueAsJSON",
                  "ActionCaption": null,
                  "AllowInsert": true,
                  "AllowUpdate": true,
                  "ListItemAction": [],
                  "Language": null,
                  "ViewTypeAction": "NONE",
                  "ActionType": "",
                  "ListItemNavigation": null,
                  "Image": null,
                  "ListItemContent": null,
                  "TemplateIdentifier": "BodyRight_def",
                  "GroupTemplateIdentifier": "Detail",
                  "DisplayTextStyle": null,
                  "MinValue": null,
                  "MaxValue": null,
                  "PostParameters": "",
                  "EditMask": null,
                  "NoticeMode": "",
                  "CreatePostParameters": true,
                  "OrderNumber": null,
                  "ValidationCode": null,
                  "Validation": null
                },
                {
                  "Dynamic": null,
                  "ID": null,
                  "DataType": "Accordion",
                  "GroupDisplayName": null,
                  "FieldName": "v_SkdID123",
                  "LabelCaption": "Konditionen123",
                  "DisplayText": "[JSON{\"Value\":\"4758\",\"Label\":\"46,00 % - Grundrabatt\",\"Style\":\"font-weight: bold;\"},{\"Value\":\"4759\",\"Label\":\"28,00 % - Ausstellungsrabatt \",\"Style\":\"\"},{\"Value\":\"4757\",\"Label\":\"10,00 % - Hausrabatt\",\"Style\":\"font-weight: bold;\"},{\"Value\":\"5621\",\"Label\":\"0,00 % - Sonderrabatt\",\"Style\":\"\"}]",
                  "EditValue": "[{\"Value\":\"4758\",\"Label\":\"46,00 % - Grundrabatt\",\"Style\":\"font-weight: bold;\"},{\"Value\":\"4759\",\"Label\":\"28,00 % - Ausstellungsrabatt \",\"Style\":\"\"},{\"Value\":\"4757\",\"Label\":\"10,00 % - Hausrabatt\",\"Style\":\"font-weight: bold;\"},{\"Value\":\"5621\",\"Label\":\"0,00 % - Sonderrabatt\",\"Style\":\"\"}]",
                  "Action": "https://vertreter.forcher.at:9001/EfwService_ForcherVertreterApp.asmx/SetValueAsJSON",
                  "ActionCaption": null,
                  "AllowInsert": true,
                  "AllowUpdate": true,
                  "ListItemAction": [],
                  "Language": null,
                  "ViewTypeAction": "NONE",
                  "ActionType": "",
                  "ListItemNavigation": null,
                  "Image": null,
                  "ListItemContent": null,
                  "TemplateIdentifier": "BodyRight_def",
                  "GroupTemplateIdentifier": "Detail",
                  "DisplayTextStyle": null,
                  "MinValue": null,
                  "MaxValue": null,
                  "PostParameters": "",
                  "EditMask": null,
                  "NoticeMode": "",
                  "CreatePostParameters": true,
                  "OrderNumber": null,
                  "ValidationCode": null,
                  "Validation": null
                },
                {
                  "Dynamic": null,
                  "ID": null,
                  "DataType": "System.Decimal",
                  "GroupDisplayName": null,
                  "FieldName": "v_SccDecimal2Ang",
                  "LabelCaption": "Anzahl",
                  "DisplayText": "-",
                  "EditValue": "-",
                  "Action": null,
                  "ActionCaption": null,
                  "AllowInsert": false,
                  "AllowUpdate": true,
                  "ListItemAction": [],
                  "Language": null,
                  "ViewTypeAction": "NONE",
                  "ActionType": "",
                  "ListItemNavigation": null,
                  "Image": null,
                  "ListItemContent": null,
                  "TemplateIdentifier": "BodyRight_def",
                  "GroupTemplateIdentifier": "Detail",
                  "DisplayTextStyle": null,
                  "MinValue": null,
                  "MaxValue": null,
                  "PostParameters": null,
                  "EditMask": null,
                  "NoticeMode": "",
                  "CreatePostParameters": true,
                  "OrderNumber": null,
                  "ValidationCode": null,
                  "Validation": null
                },
                {
                  "Dynamic": null,
                  "ID": null,
                  "DataType": "System.Image",
                  "GroupDisplayName": null,
                  "FieldName": "v_SccNvarchar2",
                  "LabelCaption": "Name",
                  "DisplayText": "-",
                  "EditValue": "-",
                  "Action": null,
                  "ActionCaption": null,
                  "AllowInsert": false,
                  "AllowUpdate": true,
                  "ListItemAction": [],
                  "Language": null,
                  "ViewTypeAction": "NONE",
                  "ActionType": "",
                  "ListItemNavigation": null,
                  "Image": "xls.png",
                  "ListItemContent": null,
                  "TemplateIdentifier": null,
                  "GroupTemplateIdentifier": "RowIcon",
                  "DisplayTextStyle": null,
                  "MinValue": null,
                  "MaxValue": null,
                  "PostParameters": null,
                  "EditMask": null,
                  "NoticeMode": "",
                  "CreatePostParameters": true,
                  "OrderNumber": null,
                  "ValidationCode": null,
                  "Validation": null
                },
                {
                  "Dynamic": null,
                  "ID": null,
                  "DataType": "System.String",
                  "GroupDisplayName": null,
                  "FieldName": "v_SccNvarchar2",
                  "LabelCaption": "Name",
                  "DisplayText": "Schlussartikel",
                  "EditValue": "-",
                  "Action": null,
                  "ActionCaption": null,
                  "AllowInsert": false,
                  "AllowUpdate": true,
                  "ListItemAction": [],
                  "Language": null,
                  "ViewTypeAction": "NONE",
                  "ActionType": "",
                  "ListItemNavigation": null,
                  "Image": null,
                  "ListItemContent": null,
                  "TemplateIdentifier": null,
                  "GroupTemplateIdentifier": "RowText",
                  "DisplayTextStyle": null,
                  "MinValue": null,
                  "MaxValue": null,
                  "PostParameters": null,
                  "EditMask": null,
                  "NoticeMode": "",
                  "CreatePostParameters": true,
                  "OrderNumber": null,
                  "ValidationCode": null,
                  "Validation": null
                },
                {
                  "Dynamic": null,
                  "ID": null,
                  "DataType": "System.String",
                  "GroupDisplayName": null,
                  "FieldName": "v_SccNvarchar3",
                  "LabelCaption": "Beschreibung",
                  "DisplayText": "Foo",
                  "EditValue": "-",
                  "Action": null,
                  "ActionCaption": null,
                  "AllowInsert": false,
                  "AllowUpdate": true,
                  "ListItemAction": [],
                  "Language": null,
                  "ViewTypeAction": "NONE",
                  "ActionType": "",
                  "ListItemNavigation": null,
                  "Image": null,
                  "ListItemContent": null,
                  "TemplateIdentifier": null,
                  "GroupTemplateIdentifier": "RowText",
                  "DisplayTextStyle": null,
                  "MinValue": null,
                  "MaxValue": null,
                  "PostParameters": null,
                  "EditMask": null,
                  "NoticeMode": "",
                  "CreatePostParameters": true,
                  "OrderNumber": null,
                  "ValidationCode": null,
                  "Validation": null
                },
                {
                  "Dynamic": null,
                  "ID": null,
                  "DataType": "System.String",
                  "GroupDisplayName": null,
                  "FieldName": "v_SccNvarchar4",
                  "LabelCaption": "Zusatztext",
                  "DisplayText": "Bar",
                  "EditValue": "-",
                  "Action": null,
                  "ActionCaption": null,
                  "AllowInsert": false,
                  "AllowUpdate": true,
                  "ListItemAction": [],
                  "Language": null,
                  "ViewTypeAction": "NONE",
                  "ActionType": "",
                  "ListItemNavigation": null,
                  "Image": null,
                  "ListItemContent": null,
                  "TemplateIdentifier": null,
                  "GroupTemplateIdentifier": "RowText",
                  "DisplayTextStyle": null,
                  "MinValue": null,
                  "MaxValue": null,
                  "PostParameters": null,
                  "EditMask": null,
                  "NoticeMode": "",
                  "CreatePostParameters": true,
                  "OrderNumber": null,
                  "ValidationCode": null,
                  "Validation": null
                }
              ],
              "ListItemAction": null
            }
          ]
        },
        {
          "ListItemContent": [
            {
              "Dynamic": null,
              "ID": null,
              "DataType": "System.Image",
              "GroupDisplayName": null,
              "FieldName": "Detailseite öffnen",
              "LabelCaption": "email.png",
              "DisplayText": "Detailseite öffnen",
              "EditValue": null,
              "Action": "nix",
              "ActionCaption": null,
              "AllowInsert": false,
              "AllowUpdate": false,
              "ListItemAction": [],
              "Language": null,
              "ViewTypeAction": "GridBox",
              "ActionType": null,
              "ListItemNavigation": null,
              "Image": null,
              "ListItemContent": null,
              "TemplateIdentifier": "BodyLeft_def",
              "GroupTemplateIdentifier": "Detail",
              "DisplayTextStyle": null,
              "MinValue": null,
              "MaxValue": null,
              "PostParameters": "nix",
              "EditMask": null,
              "NoticeMode": "",
              "CreatePostParameters": true,
              "OrderNumber": null,
              "ValidationCode": null,
              "Validation": null
            },
            {
              "Dynamic": null,
              "ID": null,
              "DataType": "System.Image",
              "GroupDisplayName": null,
              "FieldName": "Löschen",
              "LabelCaption": "delete.png",
              "DisplayText": "Löschen",
              "EditValue": null,
              "Action": "nix",
              "ActionCaption": null,
              "AllowInsert": false,
              "AllowUpdate": false,
              "ListItemAction": [],
              "Language": null,
              "ViewTypeAction": "GridBox",
              "ActionType": null,
              "ListItemNavigation": null,
              "Image": null,
              "ListItemContent": null,
              "TemplateIdentifier": "BodyLeft_def",
              "GroupTemplateIdentifier": "Detail",
              "DisplayTextStyle": null,
              "MinValue": null,
              "MaxValue": null,
              "PostParameters": "nix",
              "EditMask": null,
              "NoticeMode": "",
              "CreatePostParameters": true,
              "OrderNumber": null,
              "ValidationCode": null,
              "Validation": null
            },
            {
              "Dynamic": null,
              "ID": null,
              "DataType": "System.Decimal",
              "GroupDisplayName": null,
              "FieldName": "v_SccDecimal2Ang",
              "LabelCaption": "Anzahl",
              "DisplayText": "-",
              "EditValue": "-",
              "Action": null,
              "ActionCaption": null,
              "AllowInsert": false,
              "AllowUpdate": true,
              "ListItemAction": [],
              "Language": null,
              "ViewTypeAction": "NONE",
              "ActionType": "",
              "ListItemNavigation": null,
              "Image": null,
              "ListItemContent": null,
              "TemplateIdentifier": "BodyRight_def",
              "GroupTemplateIdentifier": "Detail",
              "DisplayTextStyle": null,
              "MinValue": null,
              "MaxValue": null,
              "PostParameters": null,
              "EditMask": null,
              "NoticeMode": "",
              "CreatePostParameters": true,
              "OrderNumber": null,
              "ValidationCode": null,
              "Validation": null
            },
            {
              "Dynamic": null,
              "ID": null,
              "DataType": "System.Image",
              "GroupDisplayName": null,
              "FieldName": "v_SccNvarchar2",
              "LabelCaption": "Name",
              "DisplayText": "-",
              "EditValue": "-",
              "Action": null,
              "ActionCaption": null,
              "AllowInsert": false,
              "AllowUpdate": true,
              "ListItemAction": [],
              "Language": null,
              "ViewTypeAction": "NONE",
              "ActionType": "",
              "ListItemNavigation": null,
              "Image": "xls.png",
              "ListItemContent": null,
              "TemplateIdentifier": null,
              "GroupTemplateIdentifier": "RowIcon",
              "DisplayTextStyle": null,
              "MinValue": null,
              "MaxValue": null,
              "PostParameters": null,
              "EditMask": null,
              "NoticeMode": "",
              "CreatePostParameters": true,
              "OrderNumber": null,
              "ValidationCode": null,
              "Validation": null
            },
            {
              "Dynamic": null,
              "ID": null,
              "DataType": "System.String",
              "GroupDisplayName": null,
              "FieldName": "v_SccNvarchar2",
              "LabelCaption": "Name",
              "DisplayText": "Artikelname",
              "EditValue": "-",
              "Action": null,
              "ActionCaption": null,
              "AllowInsert": false,
              "AllowUpdate": true,
              "ListItemAction": [],
              "Language": null,
              "ViewTypeAction": "NONE",
              "ActionType": "",
              "ListItemNavigation": null,
              "Image": null,
              "ListItemContent": null,
              "TemplateIdentifier": null,
              "GroupTemplateIdentifier": "RowText",
              "DisplayTextStyle": null,
              "MinValue": null,
              "MaxValue": null,
              "PostParameters": null,
              "EditMask": null,
              "NoticeMode": "",
              "CreatePostParameters": true,
              "OrderNumber": null,
              "ValidationCode": null,
              "Validation": null
            },
            {
              "Dynamic": null,
              "ID": null,
              "DataType": "System.String",
              "GroupDisplayName": null,
              "FieldName": "v_SccNvarchar3",
              "LabelCaption": "Beschreibung",
              "DisplayText": "Lorem",
              "EditValue": "-",
              "Action": null,
              "ActionCaption": null,
              "AllowInsert": false,
              "AllowUpdate": true,
              "ListItemAction": [],
              "Language": null,
              "ViewTypeAction": "NONE",
              "ActionType": "",
              "ListItemNavigation": null,
              "Image": null,
              "ListItemContent": null,
              "TemplateIdentifier": null,
              "GroupTemplateIdentifier": "RowText",
              "DisplayTextStyle": null,
              "MinValue": null,
              "MaxValue": null,
              "PostParameters": null,
              "EditMask": null,
              "NoticeMode": "",
              "CreatePostParameters": true,
              "OrderNumber": null,
              "ValidationCode": null,
              "Validation": null
            },
            {
              "Dynamic": null,
              "ID": null,
              "DataType": "System.String",
              "GroupDisplayName": null,
              "FieldName": "v_SccNvarchar4",
              "LabelCaption": "Zusatztext",
              "DisplayText": "Ipsum",
              "EditValue": "-",
              "Action": null,
              "ActionCaption": null,
              "AllowInsert": false,
              "AllowUpdate": true,
              "ListItemAction": [],
              "Language": null,
              "ViewTypeAction": "NONE",
              "ActionType": "",
              "ListItemNavigation": null,
              "Image": null,
              "ListItemContent": null,
              "TemplateIdentifier": null,
              "GroupTemplateIdentifier": "RowText",
              "DisplayTextStyle": null,
              "MinValue": null,
              "MaxValue": null,
              "PostParameters": null,
              "EditMask": null,
              "NoticeMode": "",
              "CreatePostParameters": true,
              "OrderNumber": null,
              "ValidationCode": null,
              "Validation": null
            }
          ],
          "ListItemAction": null
        }
      ],
      "ListItemContent": [
        {
          "Dynamic": null,
          "ID": null,
          "DataType": "System.Image",
          "GroupDisplayName": null,
          "FieldName": "Detailseite öffnen",
          "LabelCaption": "email.png",
          "DisplayText": "Detailseite öffnen",
          "EditValue": null,
          "Action": "nix",
          "ActionCaption": null,
          "AllowInsert": false,
          "AllowUpdate": false,
          "ListItemAction": [],
          "Language": null,
          "ViewTypeAction": "GridBox",
          "ActionType": null,
          "ListItemNavigation": null,
          "Image": null,
          "ListItemContent": null,
          "TemplateIdentifier": "BodyLeft_def",
          "GroupTemplateIdentifier": "Detail",
          "DisplayTextStyle": null,
          "MinValue": null,
          "MaxValue": null,
          "PostParameters": "nix",
          "EditMask": null,
          "NoticeMode": "",
          "CreatePostParameters": true,
          "OrderNumber": null,
          "ValidationCode": null,
          "Validation": null
        },
        {
          "Dynamic": null,
          "ID": null,
          "DataType": "System.Image",
          "GroupDisplayName": null,
          "FieldName": "Löschen",
          "LabelCaption": "delete.png",
          "DisplayText": "Löschen",
          "EditValue": null,
          "Action": "nix",
          "ActionCaption": null,
          "AllowInsert": false,
          "AllowUpdate": false,
          "ListItemAction": [],
          "Language": null,
          "ViewTypeAction": "GridBox",
          "ActionType": null,
          "ListItemNavigation": null,
          "Image": null,
          "ListItemContent": null,
          "TemplateIdentifier": "BodyLeft_def",
          "GroupTemplateIdentifier": "Detail",
          "DisplayTextStyle": null,
          "MinValue": null,
          "MaxValue": null,
          "PostParameters": "nix",
          "EditMask": null,
          "NoticeMode": "",
          "CreatePostParameters": true,
          "OrderNumber": null,
          "ValidationCode": null,
          "Validation": null
        },
        {
          "Dynamic": null,
          "ID": null,
          "DataType": "System.Decimal",
          "GroupDisplayName": null,
          "FieldName": "v_SccDecimal2Ang",
          "LabelCaption": "Anzahl",
          "DisplayText": "-",
          "EditValue": "-",
          "Action": null,
          "ActionCaption": null,
          "AllowInsert": false,
          "AllowUpdate": true,
          "ListItemAction": [],
          "Language": null,
          "ViewTypeAction": "NONE",
          "ActionType": "",
          "ListItemNavigation": null,
          "Image": null,
          "ListItemContent": null,
          "TemplateIdentifier": "BodyRight_def",
          "GroupTemplateIdentifier": "Detail",
          "DisplayTextStyle": null,
          "MinValue": null,
          "MaxValue": null,
          "PostParameters": null,
          "EditMask": null,
          "NoticeMode": "",
          "CreatePostParameters": true,
          "OrderNumber": null,
          "ValidationCode": null,
          "Validation": null
        },
        {
          "Dynamic": null,
          "ID": null,
          "DataType": "System.Image",
          "GroupDisplayName": null,
          "FieldName": "v_SccNvarchar2",
          "LabelCaption": "Name",
          "DisplayText": "-",
          "EditValue": "-",
          "Action": null,
          "ActionCaption": null,
          "AllowInsert": false,
          "AllowUpdate": true,
          "ListItemAction": [],
          "Language": null,
          "ViewTypeAction": "NONE",
          "ActionType": "",
          "ListItemNavigation": null,
          "Image": "xls.png",
          "ListItemContent": null,
          "TemplateIdentifier": null,
          "GroupTemplateIdentifier": "RowIcon",
          "DisplayTextStyle": null,
          "MinValue": null,
          "MaxValue": null,
          "PostParameters": null,
          "EditMask": null,
          "NoticeMode": "",
          "CreatePostParameters": true,
          "OrderNumber": null,
          "ValidationCode": null,
          "Validation": null
        },
        {
          "Dynamic": null,
          "ID": null,
          "DataType": "System.String",
          "GroupDisplayName": null,
          "FieldName": "v_SccNvarchar2",
          "LabelCaption": "Name",
          "DisplayText": "Kopfknotenname",
          "EditValue": "-",
          "Action": null,
          "ActionCaption": null,
          "AllowInsert": false,
          "AllowUpdate": true,
          "ListItemAction": [],
          "Language": null,
          "ViewTypeAction": "NONE",
          "ActionType": "",
          "ListItemNavigation": null,
          "Image": null,
          "ListItemContent": null,
          "TemplateIdentifier": null,
          "GroupTemplateIdentifier": "RowText",
          "DisplayTextStyle": null,
          "MinValue": null,
          "MaxValue": null,
          "PostParameters": null,
          "EditMask": null,
          "NoticeMode": "",
          "CreatePostParameters": true,
          "OrderNumber": null,
          "ValidationCode": null,
          "Validation": null
        },
        {
          "Dynamic": null,
          "ID": null,
          "DataType": "System.String",
          "GroupDisplayName": null,
          "FieldName": "v_SccNvarchar3",
          "LabelCaption": "Beschreibung",
          "DisplayText": "noch ein text",
          "EditValue": "-",
          "Action": null,
          "ActionCaption": null,
          "AllowInsert": false,
          "AllowUpdate": true,
          "ListItemAction": [],
          "Language": null,
          "ViewTypeAction": "NONE",
          "ActionType": "",
          "ListItemNavigation": null,
          "Image": null,
          "ListItemContent": null,
          "TemplateIdentifier": null,
          "GroupTemplateIdentifier": "RowText",
          "DisplayTextStyle": null,
          "MinValue": null,
          "MaxValue": null,
          "PostParameters": null,
          "EditMask": null,
          "NoticeMode": "",
          "CreatePostParameters": true,
          "OrderNumber": null,
          "ValidationCode": null,
          "Validation": null
        },
        {
          "Dynamic": null,
          "ID": null,
          "DataType": "System.String",
          "GroupDisplayName": null,
          "FieldName": "v_SccNvarchar4",
          "LabelCaption": "Zusatztext",
          "DisplayText": "schlusstext",
          "EditValue": "-",
          "Action": null,
          "ActionCaption": null,
          "AllowInsert": false,
          "AllowUpdate": true,
          "ListItemAction": [],
          "Language": null,
          "ViewTypeAction": "NONE",
          "ActionType": "",
          "ListItemNavigation": null,
          "Image": null,
          "ListItemContent": null,
          "TemplateIdentifier": null,
          "GroupTemplateIdentifier": "RowText",
          "DisplayTextStyle": null,
          "MinValue": null,
          "MaxValue": null,
          "PostParameters": null,
          "EditMask": null,
          "NoticeMode": "",
          "CreatePostParameters": true,
          "OrderNumber": null,
          "ValidationCode": null,
          "Validation": null
        }
      ],
      "ListItemAction": null
    }
  ]

}



// WEBPACK FOOTER //
// ./src/pages/treeview/treeview.ts